import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material';
import { SessionService } from '../../../service/session/session.module';
import { LoadingService } from '../../../directive/loading/loading.module';
import * as moment from 'moment';

@Component({
  selector: 'app-assistant-medical-appointment-other-income',
  templateUrl: './assistant-medical-appointment-other-income.component.html',
  styleUrls: ['./assistant-medical-appointment-other-income.component.css']
})
export class AssistantMedicalAppointmentOtherIncomeComponent implements OnInit {
  officeOtherIncomeModel = {
    main:{
      uuid:'',
      concept:'',
      amount:'',
      dateExpenditure:'',
    },
    system:{
      doctor:{
        main:{
          uuid:''
        }
      },
      user:{
        main:{
          uuid:''
        }
      }
    }
  };

  officeOtherIncomeList = [];

  metadata = {
    totalOfficeOtherIncome:0,
    doctor:{
      main:{
        uuid:''
      }
    }
  }
  constructor(
    private session: SessionService,
    public loadingService: LoadingService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AssistantMedicalAppointmentOtherIncomeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog:MatDialog) {
      console.log("Aqui datos enviados al modal::::::",this.data);
  }

  ngOnInit() {
    this.metadata.doctor = this.data;
    this.getOtherIncomeList();
  }

  /**función para obtener los gastos de un doctor por una fecha
  */
  getOtherIncomeList(){
    this.loadingService.show(true,"Espere un momento");
    let date =  moment().format('DD/MM/YYYY hh:mm:ss')
    this.session.getRequest("officeOtherIncome:findAllByDoctorAndDateExpenditure",{main:{dateExpenditure:date},system:{doctor:{main:{uuid:this.metadata.doctor.main.uuid}}}}).subscribe((data:any)=>{
      this.officeOtherIncomeList = data.object.instanceList;
      this.addSpending();
      this.caluclateOtherIncome();
      this.loadingService.hide();
    },error=>{
      console.log(error);
      this.loadingService.hide();
    })
  }

  /**funcion para agregar un nuevo objeto a la cuenta de gastos
  */
  addSpending(){
    let aux = JSON.parse(JSON.stringify(this.officeOtherIncomeModel));
    aux.system.doctor.main.uuid = this.metadata.doctor.main.uuid;
    aux.system.user.main.uuid = this.session.getUser().main.uuid;
    aux.main.dateExpenditure = moment().format('DD/MM/YYYY hh:mm:ss');
    this.officeOtherIncomeList.unshift(aux);
  }

  /**funcionalidad para guardar un gasto
  */
  save(object){
    this.loadingService.show(true,"Espere un momento...");
    if(object.main.uuid != ''){
      object.main.dateExpenditure = moment(object.main.dateExpenditure).format('DD/MM/YYYY hh:mm:ss');
    }
    this.session.getRequest("officeOtherIncome:update",object).subscribe((data:any)=>{
      if(object.main.uuid == ''){
        this.addSpending();
      }
      object.main.uuid = data.object.main.uuid;
      object.main.dateExpenditure = data.object.main.dateExpenditure;
      this.caluclateOtherIncome();
      this.loadingService.hide();
    },error=>{
      console.log(error);
      this.loadingService.hide();
    })
  }

  /**funcionalidad para eliminar un gasto
  */
  delete(object){
    if(object.main.uuid != ''){
      this.loadingService.show(true,"Espere un momento...");
      this.session.getRequest("officeOtherIncome:delete",object).subscribe((data:any)=>{
        for(let i = 0; this.officeOtherIncomeList.length; i++){
          if(this.officeOtherIncomeList[i].main.uuid == object.main.uuid){
            this.officeOtherIncomeList.splice(i,1);
            break;
          }
        }
        this.loadingService.hide();
        this.caluclateOtherIncome();
      },error=>{
        console.log(error);
        this.loadingService.hide();
      })
    }
  }

  /**función para calcular el total de gastos
  */
  caluclateOtherIncome(){
    this.metadata.totalOfficeOtherIncome = 0;
    for(let item of this.officeOtherIncomeList){
      let i:any =this.metadata.totalOfficeOtherIncome  + (item.main.amount*1);
      this.metadata.totalOfficeOtherIncome = i;
    }
  }

  close(status){
    let object = {
      transaction:'',
      code:'',
      object:{}
    };
    if(status){
      object.transaction = 'ok';
      object.object = this.metadata;
    }else{
      object.transaction = 'bad';
      object.code = 'officeExpenses:001';
    }
    this.dialogRef.close(object);
  }

}
